/* eslint-disable react-hooks/exhaustive-deps */
import { Search, RotateCw, Copy } from 'lucide-react'
import moment from 'moment'
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Table
} from 'react-bootstrap'
import 'react-calendar/dist/Calendar.css'
import 'react-date-picker/dist/DatePicker.css'
import { Link, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Loader from '../../../components/atoms/Loader'
import { BadgeStatusPrListInbounds } from '../../../components/atoms/StatusLabel'
import TableAction from '../../../components/atoms/Table/TableAction'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import InputDatePicker from '../../../components/Input/DatePicker/InputDatePicker'
import api from '../../../config/AxiosInstance'
import { convertDateWithoutTime } from '../../../helpers/constants'
import '../../../styles/style.css'
import * as Common from '../../../utils/Common'
import toast, { Toaster } from 'react-hot-toast'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    height: 45,
    minHeight: 45,
    borderRadius: '10px',
    borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    fontSize: '0.9rem'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '45px',
    padding: '0 12px'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#495057'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--primary-orange)'
      : state.isFocused
        ? '#fff5e6'
        : null,
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer'
  })
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const Transfer = () => {
  const navigate = useNavigate()
  const [transfers, setTransfers] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
    toast.success('Copied to clipboard')
  }
  const [warehouses, setWarehouses] = useState([])
  const [targetWarehouses, setTargetWarehouses] = useState([])
  const [filter, setFilter] = useState({
    tr: '',
    mr: '',
    src_warehouse: '',
    target_warehouse: '',
    start_date: '',
    end_date: ''
  })
  const [debouncedFilter, setDebouncedFilter] = useState({
    tr: '',
    mr: ''
  })
  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })

  useEffect(() => {
    fetchWarehouses()
    fetchTargetWarehouses()
  }, [])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedFilter({
        tr: filter.tr,
        mr: filter.mr
      })
      if (
        filter.tr !== debouncedFilter.tr ||
        filter.mr !== debouncedFilter.mr
      ) {
        setMeta({ ...meta, current_page: 1 })
      }
    }, 1000)

    return () => {
      clearTimeout(handler)
    }
  }, [filter.tr, filter.mr])

  useEffect(() => {
    if (
      (filter.start_date && !filter.end_date) ||
      (!filter.start_date && filter.end_date)
    ) {
      return
    }

    fetchTransfers()
  }, [
    meta.per_page,
    meta.current_page,
    debouncedFilter.tr,
    debouncedFilter.mr,
    filter.src_warehouse,
    filter.target_warehouse,
    filter.start_date,
    filter.end_date
  ])

  const fetchWarehouses = async () => {
    try {
      const res = await api.get(
        '/master/warehouses/all?is_parent=true&forUser=1'
      )
      const { data } = res
      if (data.success) {
        setWarehouses(data.data)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const fetchTargetWarehouses = async () => {
    try {
      const res = await api.get('/master/warehouses/all?is_transit=true')
      const { data } = res
      if (data.success) {
        setTargetWarehouses(data.data)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const fetchTransfers = async () => {
    try {
      setIsLoading(true)
      const res = await api.get('/outbound/transfer/list', {
        params: {
          tr: debouncedFilter.tr,
          mr: debouncedFilter.mr,
          src_warehouse: filter.src_warehouse,
          target_warehouse: filter.target_warehouse,
          start_date: filter.start_date,
          end_date: filter.end_date,
          per_page: meta.per_page,
          page: meta.current_page
        }
      })
      const { data } = res
      if (data.success) {
        setTransfers(data.data)
        setMeta(data.metadata)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setIsLoading(false)
    }
  }

  const handleReset = () => {
    setFilter({
      tr: '',
      mr: '',
      src_warehouse: '',
      target_warehouse: '',
      start_date: '',
      end_date: ''
    })
    setDebouncedFilter({
      tr: '',
      mr: ''
    })
    setMeta((prev) => ({ ...prev, current_page: 1 }))
  }

  const handleOnChangeMeta = (e) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    }))
  }

  const handleDateFilterChange = (name, value) => {
    const newFilter = {
      ...filter,
      [name]: value ? moment(value).format('YYYY-MM-DD') : ''
    }

    if (name === 'start_date' && value && filter.end_date) {
      if (moment(value) > moment(filter.end_date)) {
        newFilter.end_date = moment(value).format('YYYY-MM-DD')
      }
    }

    if (name === 'end_date' && value && filter.start_date) {
      if (moment(value) < moment(filter.start_date)) {
        newFilter.start_date = moment(value).format('YYYY-MM-DD')
      }
    }

    setFilter(newFilter)
    setMeta((prev) => ({ ...prev, current_page: 1 }))
  }

  const handlePageChange = (data) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: data.selected + 1
    }))
    window.scrollTo(0, 0)
  }

  return (
    <>
      <Container fluid className="px-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <h3 style={headerTitleStyle}>TR List</h3>
              <Button
                variant="light"
                className="text-secondary fw-bold rounded px-3 border"
                onClick={handleReset}
                style={{ fontSize: '0.85rem' }}
              >
                <RotateCw size={16} className="me-2" />
                Reset Filters
              </Button>
            </div>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row className="g-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>#TR</Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={18} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="tr"
                    id="tr"
                    placeholder="Search TR..."
                    onChange={(e) =>
                      setFilter({ ...filter, tr: e.target.value })
                    }
                    value={filter.tr}
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>#MR</Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={18} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="mr"
                    id="mr"
                    placeholder="Search MR..."
                    onChange={(e) =>
                      setFilter({ ...filter, mr: e.target.value })
                    }
                    value={filter.mr}
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>SOURCE WAREHOUSE</Form.Label>
                <Select
                  isClearable
                  id="src_warehouse"
                  styles={SelectStyles}
                  onChange={(e) => {
                    setFilter({ ...filter, src_warehouse: e ? e.value : '' })
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  options={warehouses.map((warehouse) => ({
                    value: warehouse.warehouse_id,
                    label: warehouse.warehouse_name
                  }))}
                  placeholder="Select Warehouse"
                  value={
                    filter.src_warehouse
                      ? {
                          value: filter.src_warehouse,
                          label: warehouses.find(
                            (w) => w.warehouse_id === filter.src_warehouse
                          )?.warehouse_name
                        }
                      : null
                  }
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>
                  DESTINATION WAREHOUSE
                </Form.Label>
                <Select
                  isClearable
                  id="target_warehouse"
                  styles={SelectStyles}
                  onChange={(e) => {
                    setFilter({ ...filter, target_warehouse: e ? e.value : '' })
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  options={targetWarehouses.map((warehouse) => ({
                    value: warehouse.warehouse_id,
                    label: warehouse.warehouse_name
                  }))}
                  placeholder="Select Warehouse"
                  value={
                    filter.target_warehouse
                      ? {
                          value: filter.target_warehouse,
                          label: targetWarehouses.find(
                            (w) => w.warehouse_id === filter.target_warehouse
                          )?.warehouse_name
                        }
                      : null
                  }
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Start Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter.start_date}
                    onChange={(date) =>
                      handleDateFilterChange('start_date', date)
                    }
                    maxDate={filter.end_date ? new Date(filter.end_date) : null}
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>End Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter.end_date}
                    onChange={(date) =>
                      handleDateFilterChange('end_date', date)
                    }
                    minDate={
                      filter.start_date ? new Date(filter.start_date) : null
                    }
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card>

        <Row className="mt-4">
          <Col md={12}>
            <Table
              hover
              size="sm"
              responsive
              className="shadow-sm mb-5 bg-white"
              style={{
                borderRadius: '12px',
                overflow: 'hidden',
                fontSize: '0.9rem'
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #TR
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #MR
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Source Warehouse
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Destination Warehouse
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #Outbound
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Status
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Delivery Date
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: '13px' }}>
                {isLoading && (
                  <tr>
                    <td className="text-center p-5" colSpan={8}>
                      <Loader />
                    </td>
                  </tr>
                )}
                {!isLoading && transfers.length === 0 && (
                  <tr>
                    <td
                      className="text-center fw-bold p-5 text-muted"
                      colSpan={8}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
                {!isLoading &&
                  transfers.length > 0 &&
                  transfers.map((transfer) => (
                    <tr
                      key={transfer.id}
                      style={{ borderBottom: '1px solid #f0f0f0' }}
                    >
                      <td className="p-2 align-middle fw-semibold text-primary">
                        <div className="d-flex align-items-center gap-2">
                          {transfer.tr}
                          <Copy
                            size={14}
                            className="text-muted cursor-pointer"
                            style={{
                              cursor: 'pointer',
                              opacity: 0.5,
                              transition: 'opacity 0.2s'
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.opacity = 1)
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.opacity = 0.5)
                            }
                            onClick={() => handleCopy(transfer.tr)}
                            title="Copy TR Number"
                          />
                        </div>
                      </td>
                      <td className="p-2 align-middle">
                        <div className="d-flex align-items-center gap-2">
                          {transfer.mr}
                          <Copy
                            size={14}
                            className="text-muted cursor-pointer"
                            style={{
                              cursor: 'pointer',
                              opacity: 0.5,
                              transition: 'opacity 0.2s'
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.opacity = 1)
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.opacity = 0.5)
                            }
                            onClick={() => handleCopy(transfer.mr)}
                            title="Copy MR Number"
                          />
                        </div>
                      </td>
                      <td className="p-2 align-middle text-muted">
                        {transfer.src_warehouse}
                      </td>
                      <td className="p-2 align-middle text-muted">
                        {transfer.target_warehouse}
                      </td>
                      <td className="p-2 align-middle">
                        {!transfer.outbound && '-'}
                        {transfer.outbound && (
                          <Link
                            to={`/outbound/plan/detail/${transfer?.outbound_id}`}
                            className="text-decoration-none"
                          >
                            {transfer.outbound}
                          </Link>
                        )}
                      </td>
                      <td className="p-2 align-middle">
                        {<BadgeStatusPrListInbounds text={transfer.status} />}
                      </td>
                      <td className="p-2 align-middle">
                        {transfer.delivery_date
                          ? convertDateWithoutTime(transfer.delivery_date)
                          : '-'}
                      </td>
                      <td className="p-2 align-middle text-end">
                        <TableAction>
                          <Button
                            variant="light"
                            className="btn-sm border rounded text-secondary"
                            style={{
                              width: '32px',
                              height: '32px',
                              padding: 0
                            }}
                            onClick={() =>
                              navigate(
                                `/outbound/transfer/detail/${transfer.id}`,
                                { replace: true }
                              )
                            }
                          >
                            <Search size={14} />
                          </Button>
                        </TableAction>
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="p-3 border-top-0" colSpan={8}>
                    <TablePagination
                      meta={meta}
                      handleOnChangeMeta={handleOnChangeMeta}
                      handlePageChange={handlePageChange}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </Col>
        </Row>
      </Container>
      <Toaster />
    </>
  )
}

export default Transfer
